import { Image } from "components";
import styled from "styled-components";
import { theme } from "ui";

export const Title = styled.h4`
  font-size: ${theme.typography.fontSize.sm.x3};
  font-weight: ${theme.typography.fontWeight["700"]};
  color: ${theme.colors.neutral["520"]};
`;

export const Flags = styled.div`
  display: flex;
  gap: ${theme.space.x1};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.space["x3.5"]};
`;

export const Card = styled(Image)``;
